import { PayloadAction } from '@reduxjs/toolkit';

import {
  AssetParamIds,
  AssetsParams,
  PortfolioAssetsSliceState,
  PortfolioTableColumns,
} from '@hcs/types';
import { createHcReduxSlice } from '@hcs/utils';

const initialState: PortfolioAssetsSliceState = {
  filters: {},
  order: {
    orderBy: undefined,
    orderDirection: 'ASC',
  },
};

export const portfolioAssetsSlice = createHcReduxSlice({
  name: 'portfolioAssetsSlice',
  initialState,
  reducers: {
    tableChangeFilter: (
      state: PortfolioAssetsSliceState,
      action: PayloadAction<{ filterChanges: AssetsParams }>,
    ) => {
      let field: AssetParamIds;
      for (field in action.payload.filterChanges) {
        const filterValue = action.payload.filterChanges[field];
        state.filters = {
          ...state.filters,
          [field]: filterValue ? filterValue : undefined,
        };
      }
    },
    tableChangeOrder(
      state,
      action: PayloadAction<{
        orderBy?: PortfolioTableColumns | 'address';
        orderDirection: 'ASC' | 'DESC';
      }>,
    ) {
      state.order.orderBy = action.payload.orderBy;
      state.order.orderDirection = action.payload.orderDirection;
    },
    clearFilters(state) {
      state.filters = initialState.filters;
    },
  },
});
